import {inject} from '@angular/core';
import {BehaviorSubject, Observable, Subject} from 'rxjs';
import {
    WidgetImplementation,
    WidgetImplementationEvent,
    WidgetImplementationEventFlags
} from '../../components/layout/widget/widget-implementation';
import {setWidgetSettings, updateWidgetSettings} from '../components/common-widget.implementation';
import {DexTxHistoryWidgetSettings} from './settings/dex-tx-history-widget-settings';
import {DexTxHistoryWidgetSettingsService} from './settings/dex-tx-history-widget-settings.service';

export class DexTxHistoryWidgetImplementation implements WidgetImplementation {

    public settings: DexTxHistoryWidgetSettings;

    public readonly settingsService = inject(DexTxHistoryWidgetSettingsService);

    public readonly ready$ = new BehaviorSubject<boolean>(false);

    public readonly event$ = new Subject<WidgetImplementationEvent>();

    public setSettings(
        settings?: DexTxHistoryWidgetSettings,
        flags?: WidgetImplementationEventFlags
    ): Observable<DexTxHistoryWidgetSettings> {
        return setWidgetSettings(this, settings, flags);
    }

    public updateSettings(
        updates?: Partial<DexTxHistoryWidgetSettings>,
        flags?: WidgetImplementationEventFlags
    ): Observable<Partial<DexTxHistoryWidgetSettings>> {
        return updateWidgetSettings(this, updates, flags);
    }

}
